import { CCol, CRow } from "@coreui/react"
import cross from "assets/icons/Cross.svg"
import CMSTypography, {
  StandardTypographyTypes
} from "components/common/typography/CMSTypography"
import PropTypes from "prop-types"
import React from "react"

function Banner({ setShowBanner, title, information }) {
  return (
    <CRow className="my-3 mr-1 background-white card-style rounded banner">
      <img
        src={cross}
        alt="cross"
        className="cross-icon"
        width="15"
        height="15"
        tabIndex={0}
        onClick={() => setShowBanner(false)}
      />

      <CCol
        xs="12"
        sm="6"
        md="6"
        lg="5"
        className="banner-title d-flex justify-content-left pl-4 align-items-center color-blue"
      >
        <CMSTypography type={StandardTypographyTypes.cardHeading}>
          {title}
        </CMSTypography>
      </CCol>

      <CCol
        xs="12"
        sm="6"
        md="6"
        lg="7"
        className="title d-flex justify-content-center align-items-center borderRightBottomRad"
      >
        <ul className="z-index dashboardULStyles">
          {information?.map((info, index) => (
            <CMSTypography
              key={"banner-item-" + index}
              type={StandardTypographyTypes.cardContent}
            >
              {info}
            </CMSTypography>
          ))}
        </ul>
      </CCol>
    </CRow>
  )
}

Banner.propTypes = {
  setShowBanner: PropTypes.func,
  title: PropTypes.string,
  information: PropTypes.array
}

export default Banner
